module.exports = __webpack_public_path__ + "static/media/musculation-jeunes.bae83419.png";